// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__mwK50","title":"styles_title__LJ92K","description":"styles_description__9No3y","information":"styles_information__Ms_mj","income":"styles_income__4IkeN"};